/**
 * @generated SignedSource<<00aa382eb71a38e27ecc2553224c225c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WatchArtistAction_artist$data = {
  readonly id: string;
  readonly watching: boolean | null;
  readonly " $fragmentType": "WatchArtistAction_artist";
};
export type WatchArtistAction_artist$key = {
  readonly " $data"?: WatchArtistAction_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"WatchArtistAction_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WatchArtistAction_artist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "watching",
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "8a84ce6a489e6f371a008df2d858d8c5";

export default node;
